(() => {
  if (customElements.get('dyefor-details')) return;
  class DyeforDetails extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dyefor-details__track');
      this.cards = [...this.querySelectorAll('.dyefor-details__card')];
      this.navigation = this.querySelector('.dyefor-details__navigation');
      if (!this.track || !this.navigation || !this.cards.length) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.buttons = [...this.querySelectorAll('[data-details-direction]')];
      this.position = this.querySelector('.dyefor-details__position');
      this.update = () => {
        const track = this.track.getBoundingClientRect();
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
        this.index = this.cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - track.left - padding) < Math.abs(this.cards[best].getBoundingClientRect().left - track.left - padding) ? index : best, 0);
        this.navigation.hidden = !overflow;
        this.position.textContent = `${this.index + 1} / ${this.cards.length}`;
        this.buttons[0].disabled = this.index === 0;
        this.buttons[1].disabled = this.index === this.cards.length - 1;
      };
      this.go = (direction) => {
        const next = Math.max(0, Math.min(this.cards.length - 1, this.index + direction));
        const card = this.cards[next].getBoundingClientRect(), track = this.track.getBoundingClientRect();
        const padding = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        this.track.scrollBy({left: card.left - track.left - padding, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      for (const button of this.buttons) button.addEventListener('click', () => this.go(Number(button.dataset.detailsDirection)), options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.observer?.disconnect();
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  }
  customElements.define('dyefor-details', DyeforDetails);
})();
